import { render, staticRenderFns } from "./CrudLocalPrestacaoServico.vue?vue&type=template&id=1e164422"
import script from "./CrudLocalPrestacaoServico.vue?vue&type=script&lang=js"
export * from "./CrudLocalPrestacaoServico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports